import React from 'react'

import { Board2019 } from '../../../config/images'

const Board2019Array = [
	{ path: '55439561_2519303181478191_947955962910605312_o-thumb.jpg', w: 150, h: 136 },
	{ path: '55439561_2519303181478191_947955962910605312_o.jpg', w: 1200, h: 1091 },
	{ path: '54799701_2519303654811477_2083435102817222656_o-thumb.jpg', w: 150, h: 136 },
	{ path: '54799701_2519303654811477_2083435102817222656_o.jpg', w: 1200, h: 1091 },
	{ path: '55831609_2519305598144616_441807128072552448_o-thumb.jpg', w: 150, h: 136 },
	{ path: '55831609_2519305598144616_441807128072552448_o.jpg', w: 1200, h: 1091 },
	{ path: '56119817_2519305981477911_7562702118444859392_o-thumb.jpg', w: 150, h: 136 },
	{ path: '56119817_2519305981477911_7562702118444859392_o.jpg', w: 1200, h: 1091 },
	{ path: '55942629_2519308344811008_1615094306740109312_o-thumb.jpg', w: 150, h: 136 },
	{ path: '55942629_2519308344811008_1615094306740109312_o.jpg', w: 1200, h: 1091 },
	{ path: '54799924_2519308764810966_1752421994789339136_o-thumb.jpg', w: 150, h: 136 },
	{ path: '54799924_2519308764810966_1752421994789339136_o.jpg', w: 1200, h: 1091 },
	{ path: '55473413_2519309358144240_8902220053479424000_o-thumb.jpg', w: 150, h: 136 },
	{ path: '55473413_2519309358144240_8902220053479424000_o.jpg', w: 1200, h: 1091 },
	{ path: '55467814_2519309748144201_6379206253486276608_o-thumb.jpg', w: 150, h: 136 },
	{ path: '55467814_2519309748144201_6379206253486276608_o.jpg', w: 1200, h: 1091 },
	{ path: '55637157_2519310768144099_9161457708166021120_o-thumb.jpg', w: 150, h: 82 },
	{ path: '55637157_2519310768144099_9161457708166021120_o.jpg', w: 1200, h: 652 },
	{ path: '55554582_2519314731477036_1520564228333764608_o-thumb.jpg', w: 150, h: 73 },
	{ path: '55554582_2519314731477036_1520564228333764608_o.jpg', w: 1200, h: 585 },
	{ path: '54799989_2519318078143368_4538865045492203520_o-thumb.jpg', w: 150, h: 93 },
	{ path: '54799989_2519318078143368_4538865045492203520_o.jpg', w: 1200, h: 743 },
	{ path: '55509703_2519319664809876_7328184680606334976_o-thumb.jpg', w: 150, h: 100 },
	{ path: '55509703_2519319664809876_7328184680606334976_o.jpg', w: 1200, h: 800 },
	{ path: '55840540_2519320791476430_1033812281848233984_o-thumb.jpg', w: 150, h: 100 },
	{ path: '55840540_2519320791476430_1033812281848233984_o.jpg', w: 1200, h: 800 },
	{ path: '55783929_2519322668142909_6192077710970322944_o-thumb.jpg', w: 150, h: 100 },
	{ path: '55783929_2519322668142909_6192077710970322944_o.jpg', w: 1200, h: 800 },
]

// const newArray = First2019MeetingArray.sort((a, b) => {
// 	if (a.path < b.path) return -1
// 	if (a.path > b.path) return 1
// 	return 0
// })

//TODO: To improve this group thumb and full and make a nice full object.

export default () => {
	const componentArray = []
	for (let i = 0; i < Board2019Array.length; i++) {
		componentArray.push(
			<figure
				itemProp="associatedMedia"
				itemScope="itemScope"
				itemType="http://schema.org/ImageObject"
				key={Board2019Array[i].path}
			>
				<a
					href={Board2019[Board2019Array[i + 1].path]}
					itemProp="contentUrl"
					data-size={`${Board2019Array[i + 1].w}x${Board2019Array[i + 1].h}`}
				>
					<img
						src={Board2019[Board2019Array[i].path]}
						itemProp="thumbnail"
						alt="description"
					/>
				</a>
				<figcaption itemProp="caption description">
					{Board2019Array[i + 1].caption}
				</figcaption>
			</figure>
		)
		i++
	}
	return componentArray
}
